<!-- header start -->

<header class="mangmt-header">
    <div class="container-xxl">
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="container-fluid">
                <a class="navbar-brand">
                    <img src="../../../../assets/images/FCIlogofinal.svg" alt="Food Corporation Of India">
                </a>
                <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav"
                    aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
                </button>
                <div class="header-right align-items-center justify-content-between collapse navbar-collapse"
                    id="navbarNav">
                    <select class="form-select right-side">
                        <option selected>English</option>
                        <option value="1">Hindi</option>
                        <option value="2">Odia</option>
                    </select>
                    <div class="theme  right-side">
                        <div title="Theme mode" class="theme-mode">
                            <input type="radio" name="theame" value="light" class="active" checked>
                            <span><i class="bi bi-brightness-high-fill"></i></span>
                        </div>
                        <div title="Theme mode" class="theme-mode">
                            <input type="radio" name="theame" value="dark">
                            <span><i class="bi bi-moon-fill"></i></span>
                        </div>
                    </div>
                    <div class="notification right-side">
                        <button type="button" class="icon-button">
                            <span class="fa fa-bell"></span>
                            <span class="icon-button__badge">6</span>
                        </button>
                        <div class="notification-container">
                            <h3>Notifications
                                <i class="fa fa-cog right"></i>
                            </h3>
                            <ul>
                                <li> new <a href="#">guest account(s)</a> have been created. <i
                                        class="fa fa-close right"></i></li>
                                <li> new <a href="#">tasks</a> <i class="fa fa-close right"></i></li>
                                <li> new <a href="#">guest account(s)</a> have been created. <i
                                        class="fa fa-close right"></i></li>
                                <li> new <a href="#">tasks</a> <i class="fa fa-close right"></i></li>
                                <li> new <a href="#">guest account(s)</a> have been created. <i
                                        class="fa fa-close right"></i></li>
                                <li> new <a href="#">tasks</a> <i class="fa fa-close right"></i></li>
                            </ul>
                        </div>
                    </div>

                    <div class="account  right-side">
                        <div class="account-img">
                            <img src="../../../../assets/images/user.png" alt="user-image">
                        </div>
                        <div class="account-dropdown">
                            <div class="p-2 border-bottom">
                                Hi, Admin
                            </div>
                            <a href="javascript:void(0)" class=""><i class="fa fa-user-circle"></i> Profile</a>
                            <a routerLink="javascript:void(0)" class=""><i class="fa fa-lock"></i> Change
                                Password</a>
                            <a href="javascript:void(0)" class=""><i class="fa fa-sign-out"></i>Sign
                                Out</a>
                        </div>
                    </div>


                </div>
            </div>
        </nav>
    </div>
</header>
<!-- header end -->

<div class="mangmnt-dash">
    <div class="container-xxl">
        <div class="text-right d-flex align-items-start justify-content-between top-select">
            <div class="heading">
                <h2>Level</h2>
            </div>
            <div class="d-flex align-items-start">
                <select class="form-select me-2">
                    <option selected>- Select State -</option>
                    <option value="1">Punjab</option>
                    <option value="2">Haryana</option>
                    <option value="3">Bihar</option>
                </select>
                <select class="form-select">
                    <option selected>- Select Region -</option>
                    <option value="1">Punjab</option>
                    <option value="2">Haryana</option>
                    <option value="3">Bihar</option>
                    <option value="3">West Bengal</option>
                </select>
            </div>
        </div>

        <div class="row">
            <!-- allocation offtake start -->
            <div class="col-lg-6">
                <div class="card">
                    <div class="card-header">
                        <div class="title d-flex justify-content-between">
                            <h2 id="allocationTable">Allocation - Offtake (MT)</h2>
                            <div class="view-data">
                                <ul>
                                    <li><a (click)="ToggleManagement(true)"><i class="fa fa-bar-chart"></i></a></li>
                                    <li><a (click)="ToggleManagement(false)" class="active"><i
                                                class="fa fa-table"></i></a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="content-details" [hidden]="ShowMangmntTabView">
                            <div class="table-responsive">
                                <table class="table table-sm table-hover" aria-describedby="allocationTable">
                                    <tbody>
                                        <tr>
                                            <td colspan="2">
                                                <div class="row">
                                                    <div class="col-md-6 col-sm-6 bott-space1">
                                                        <label>
                                                            Commodity</label>
                                                        <select class="form-select">
                                                            <option selected>- Select State -</option>
                                                            <option value="1">Punjab</option>
                                                            <option value="2">Haryana</option>
                                                            <option value="3">Bihar</option>
                                                        </select>
                                                    </div>

                                                    <div class="col-md-6 col-sm-6 bott-space">
                                                        <label>
                                                            Scheme</label>
                                                        <select class="form-select">
                                                            <option selected>- Select State -</option>
                                                            <option value="1">Punjab</option>
                                                            <option value="2">Haryana</option>
                                                            <option value="3">Bihar</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th class="text-left fw-normal" scope="col">
                                                Allocation(Excluding OMSS-D)
                                            </th>
                                            <td class="text-right">
                                                46,76,130.00
                                            </td>
                                        </tr>
                                        <tr>
                                            <th class="text-left fw-normal" scope="col">
                                                Day's Offtake(Excluding OMSS-D lifting)
                                            </th>
                                            <td class="text-right">
                                                1,46,014.00
                                            </td>
                                        </tr>
                                        <tr>
                                            <th class="text-left fw-normal" scope="col">
                                                Progressive Offtake(Excluding OMSS-D lifting)
                                            </th>
                                            <td class="text-right">
                                                31,95,018.00
                                            </td>
                                        </tr>
                                        <tr>
                                            <th class="text-left fw-normal" scope="col">
                                                % Offtake(Excluding OMSS-D)
                                            </th>
                                            <td class="text-right">
                                                68.33
                                            </td>
                                        </tr>
                                        <tr>
                                            <th class="text-left fw-normal" scope="col">
                                                Lifting(OMSS-D)
                                            </th>
                                            <td class="text-right">
                                                30,066.00
                                            </td>
                                        </tr>
                                        <tr>
                                            <th class="text-left fw-normal" scope="col">
                                                Progressive Lifting(OMSS-D)
                                            </th>
                                            <td class="text-right">
                                                5,65,944.00
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="mangmnt_graph" [hidden]="!ShowMangmntTabView">
                            <div id="allocation-column"></div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- procurement kms Start -->
            <div class="col-lg-6">
                <div class="card">
                    <div class="card-header">
                        <div class="title d-flex justify-content-between">
                            <div class="card-heading">
                                <h2>Procurement</h2>
                                <select class="form-select">
                                    <option selected="selected">Kharif</option>
                                    <option>Rabi</option>
                                    <option>Kharib + Rabi</option>
                                </select>
                            </div>
                            <div class="view-data">
                                <div class="year">
                                    <h2> KMS 2023-2024</h2>
                                </div>
                                <ul>
                                    <li><a (click)="ToggleKms(true)"><i class="fa fa-bar-chart"></i></a></li>
                                    <li><a (click)="ToggleKms(false)" class="active"><i class="fa fa-table"></i></a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="content-details" [hidden]="ShowKmsTabView">
                            <div class="table-responsive">
                                <table class="table table-sm table-hover" aria-labelledby="table">
                                    <thead>
                                        <tr>
                                            <th style="width: 25%">
                                                Commodity
                                            </th>
                                            <th class="text-center" style="width: 25%">
                                                Estimate (LMT)
                                            </th>
                                            <th style="width: 25%">
                                                Payment Due (Cr.)
                                            </th>
                                            <th style="width: 25%">
                                                Payment Made (Cr.)
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td class="text-center">
                                                <select class="form-select">
                                                    <option selected="selected">Paddy</option>

                                                </select>
                                            </td>
                                            <td class="text-center">
                                                776.06
                                            </td>
                                            <td class="text-center">
                                                34,794.00
                                            </td>
                                            <td class="text-center">
                                                30,375.00
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <table class="table table-sm table-hover mt-1" aria-labelledby="table">
                                    <thead>
                                        <tr>
                                            <th class="text-center" style="width: 50%">
                                            </th>
                                            <th style="width: 25%" class="text-right">
                                                Day's
                                            </th>
                                            <th class="text-right" style="width: 25%">
                                                Progressive
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                        <tr>
                                            <td class="text-left">
                                                Procurement (MT)
                                            </td>
                                            <td class="text-right">
                                                15,83,455.00
                                            </td>
                                            <td class="text-right">
                                                1,54,45,846.00
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="text-left">
                                                Corresponding Proc. last Year (MT)
                                            </td>
                                            <td class="text-right">
                                                10,99,585.00
                                            </td>
                                            <td class="text-right">
                                                1,70,27,002.00
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="text-left">
                                                Farmers Benefitted
                                            </td>
                                            <td class="text-right">
                                                78,605
                                            </td>
                                            <td class="text-right">
                                                8,95,466
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="mangmnt_graph" [hidden]="!ShowKmsTabView">
                            <div id="kms-column"></div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- State Agency Storage start -->
            <div class="col-lg-6">
                <div class="card">
                    <div class="card-header">
                        <div class="title d-flex justify-content-between">
                            <h2>State Agency storage (in MTs)</h2>
                            <div class="view-data">
                                <ul>
                                    <li><a (click)="ToggleAgency(true)"><i class="fa fa-bar-chart"></i></a></li>
                                    <li><a (click)="ToggleAgency(false)" class="active"><i class="fa fa-table"></i></a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="content-details" [hidden]="ShowAgencyTabView">
                            <div class="table-responsive">
                                <table class="table table-sm table-hover" aria-labelledby="table">
                                    <thead>
                                        <tr>
                                            <th class="text-center" style="width: 25%">
                                            </th>
                                            <th class="text-right" style="width: 25%">
                                                Capacity
                                            </th>
                                            <th class="text-right" style="width: 25%">
                                                Stock
                                            </th>
                                            <th class="text-right" style="width: 25%">
                                                % Utilization
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                        <tr>
                                            <td class="text-left">
                                                Covered
                                            </td>
                                            <td class="text-right">
                                                3,55,58,844
                                            </td>
                                            <td class="text-right">
                                                2,67,07,872.00
                                            </td>
                                            <td class="text-right">
                                                75.11
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="text-left">
                                                Scientific CAP
                                            </td>
                                            <td class="text-right">
                                                0
                                            </td>
                                            <td class="text-right">
                                                0.00
                                            </td>
                                            <td class="text-right">
                                                0.00
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="text-left">
                                                Silo
                                            </td>
                                            <td class="text-right">
                                                13,35,000
                                            </td>
                                            <td class="text-right">
                                                11,16,863.00
                                            </td>
                                            <td class="text-right">
                                                83.66
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="text-left">
                                                Total
                                            </td>
                                            <td class="text-right">
                                                3,68,93,844
                                            </td>
                                            <td class="text-right">
                                                2,78,24,735.00
                                            </td>
                                            <td class="text-right">
                                                75.42
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="mangmnt_graph" [hidden]="!ShowAgencyTabView">
                            <div id="agency-column"></div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Total storage (in MTs) start -->
            <div class="col-lg-6">
                <div class="card">
                    <div class="card-header">
                        <div class="title d-flex justify-content-between">
                            <h2>Total storage (in MTs) (in MTs)</h2>
                            <div class="view-data">
                                <ul>
                                    <li><a (click)="ToggleTotal(true)"><i class="fa fa-bar-chart"></i></a></li>
                                    <li><a (click)="ToggleTotal(false)" class="active"><i class="fa fa-table"></i></a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="content-details" [hidden]="ShowTotalTabView">
                            <div class="table-responsive">
                                <table class="table table-sm table-hover" aria-labelledby="table">
                                    <thead>
                                        <tr>
                                            <th class="text-center" style="width: 25%">
                                            </th>
                                            <th class="text-right" style="width: 25%">
                                                Capacity
                                            </th>
                                            <th class="text-right" style="width: 25%">
                                                Stock
                                            </th>
                                            <th class="text-right" style="width: 25%">
                                                % Utilization
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                        <tr>
                                            <td class="text-left">
                                                Covered
                                            </td>
                                            <td class="text-right">
                                                7,32,23,738
                                            </td>
                                            <td class="text-right">
                                                4,03,26,302.43
                                            </td>
                                            <td class="text-right">
                                                55.07
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="text-left">
                                                Scientific CAP
                                            </td>
                                            <td class="text-right">
                                                0
                                            </td>
                                            <td class="text-right">
                                                0.00
                                            </td>
                                            <td class="text-right">
                                                0.00
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="text-left">
                                                Silo
                                            </td>
                                            <td class="text-right">
                                                13,35,000
                                            </td>
                                            <td class="text-right">
                                                11,16,863.00
                                            </td>
                                            <td class="text-right">
                                                83.66
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="text-left">
                                                Total
                                            </td>
                                            <td class="text-right">
                                                7,45,58,738
                                            </td>
                                            <td class="text-right">
                                                4,14,43,165.43
                                            </td>
                                            <td class="text-right">
                                                55.58
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="mangmnt_graph" [hidden]="!ShowTotalTabView">
                            <div id="total-column"></div>
                        </div>
                    </div>
                </div>
            </div>


            <!-- VIP References - Pending start -->
            <div class="col-lg-6">
                <div class="card">
                    <div class="card-header">
                        <div class="title d-flex justify-content-between">
                            <h2 id="referenceTable">VIP References - Pending</h2>
                            <div class="view-data">
                                <ul>
                                    <li><a (click)="ToggleReference(true)"><i class="fa fa-bar-chart"></i></a></li>
                                    <li><a (click)="ToggleReference(false)" class="active"><i
                                                class="fa fa-table"></i></a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="content-details" [hidden]="ShowReferenceTabView">
                            <div class="table-responsive">
                                <table class="table table-sm table-hover" aria-describedby="referenceTable">
                                    <tbody>
                                        <tr>
                                            <th class="text-left fw-normal">
                                                Upto 1 month
                                            </th>
                                            <td class="text-right">
                                                18
                                            </td>
                                        </tr>
                                        <tr>
                                            <th class="text-left fw-normal">
                                                1 to 3 months
                                            </th>
                                            <td class="text-right">
                                                40
                                            </td>
                                        </tr>
                                        <tr>
                                            <th class="text-left fw-normal">
                                                3 to 6 months
                                            </th>
                                            <td class="text-right">
                                                50
                                            </td>
                                        </tr>
                                        <tr>
                                            <th class="text-left fw-normal">
                                                More than 6 months
                                            </th>
                                            <td class="text-right">
                                               20
                                            </td>
                                        </tr>

                                        <tr>
                                            <th class="text-left fw-normal">
                                                Total
                                            </th>
                                            <td class="text-right">
                                                18
                                            </td>
                                        </tr>

                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="mangmnt_graph" [hidden]="!ShowReferenceTabView">
                            <div id="reference-column"></div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- FCI Storage start -->
            <div class="col-lg-6">
                <div class="card">
                    <div class="card-header">
                        <div class="title d-flex justify-content-between">
                            <h2>FCI storage (in MTs)</h2>
                            <div class="view-data">
                                <ul>
                                    <li><a (click)="ToggleFci(true)"><i class="fa fa-bar-chart"></i></a></li>
                                    <li><a (click)="ToggleFci(false)" class="active"><i class="fa fa-table"></i></a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="content-details" [hidden]="ShowFciTabView">
                            <div class="table-responsive">
                                <table class="table table-sm table-hover" aria-labelledby="table">
                                    <thead>
                                        <tr>
                                            <th class="text-center" style="width: 25%">
                                            </th>
                                            <th class="text-right" style="width: 25%">
                                                Capacity
                                            </th>
                                            <th class="text-right" style="width: 25%">
                                                Stock
                                            </th>
                                            <th class="text-right" style="width: 25%">
                                                % Utilization
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                        <tr>
                                            <td class="text-left">
                                                Covered
                                            </td>
                                            <td class="text-right">
                                                3,55,58,844
                                            </td>
                                            <td class="text-right">
                                                2,67,07,872.00
                                            </td>
                                            <td class="text-right">
                                                75.11
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="text-left">
                                                Scientific CAP
                                            </td>
                                            <td class="text-right">
                                                0
                                            </td>
                                            <td class="text-right">
                                                0.00
                                            </td>
                                            <td class="text-right">
                                                0.00
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="text-left">
                                                Silo
                                            </td>
                                            <td class="text-right">
                                                13,35,000
                                            </td>
                                            <td class="text-right">
                                                11,16,863.00
                                            </td>
                                            <td class="text-right">
                                                83.66
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="text-left">
                                                Total
                                            </td>
                                            <td class="text-right">
                                                3,68,93,844
                                            </td>
                                            <td class="text-right">
                                                2,78,24,735.00
                                            </td>
                                            <td class="text-right">
                                                75.42
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="mangmnt_graph" [hidden]="!ShowFciTabView">
                            <div id="fci-column"></div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- procurement rms start -->
            <div class="col-lg-6">
                <div class="card">
                    <div class="card-header">
                        <div class="title d-flex justify-content-between">
                            <div class="card-heading">
                                <h2>Procurement</h2>
                                <select class="form-select">
                                    <option selected="selected">Rabi</option>
                                    <option>Kharif</option>
                                    <option>Rabi + Kharif</option>
                                </select>
                            </div>
                            <div class="view-data">
                                <div class="year">
                                    <h2> RMS 2023-2024</h2>
                                </div>
                                <ul>
                                    <li><a (click)="ToggleRms(true)"><i class="fa fa-bar-chart"></i></a></li>
                                    <li><a (click)="ToggleRms(false)" class="active"><i class="fa fa-table"></i></a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="content-details" [hidden]="ShowRmsTabView">
                            <div class="table-responsive">
                                <table class="table table-sm table-hover" aria-labelledby="table">
                                    <thead>
                                        <tr>
                                            <th style="width: 25%">
                                                Commodity
                                            </th>
                                            <th class="text-center" style="width: 25%">
                                                Estimate (LMT)
                                            </th>
                                            <th style="width: 25%">
                                                Payment Due (Cr.)
                                            </th>
                                            <th style="width: 25%">
                                                Payment Made (Cr.)
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                        <tr>
                                            <td class="text-center">
                                                <select class="form-select">
                                                    <option selected="selected">Wheat</option>

                                                </select>
                                            </td>
                                            <td class="text-center">
                                                341.50
                                            </td>
                                            <td class="text-center">
                                                55,648.07
                                            </td>
                                            <td class="text-center">
                                                55,014.40
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <table class="table table-sm table-hover mt-1" aria-labelledby="table">
                                    <thead>
                                        <tr>
                                            <th class="text-center" style="width: 50%">
                                            </th>
                                            <th style="width: 25%" class="text-right">
                                                Day's
                                            </th>
                                            <th class="text-right" style="width: 25%">
                                                Progressive
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                        <tr>
                                            <td class="text-left">
                                                Procurement (MT)
                                            </td>
                                            <td class="text-right">
                                                0.00
                                            </td>
                                            <td class="text-right">
                                                2,62,02,224.34
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="text-left">
                                                Corresponding Proc. last Year (MT)
                                            </td>
                                            <td class="text-right">
                                                0.00
                                            </td>
                                            <td class="text-right">
                                                1,86,32,883.00
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="text-left">
                                                Farmers Benefitted
                                            </td>
                                            <td class="text-right">
                                                0
                                            </td>
                                            <td class="text-right">
                                                21,28,985
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="mangmnt_graph" [hidden]="!ShowRmsTabView">
                            <div id="rms-column"></div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Public Grievances - Pending start -->
            <div class="col-lg-6">
                <div class="card">
                    <div class="card-header">
                        <div class="title d-flex justify-content-between">
                            <h2 id="publicTable">Public Grievances - Pending</h2>
                            <div class="view-data">
                                <ul>
                                    <li><a (click)="TogglePublic(true)"><i class="fa fa-bar-chart"></i></a></li>
                                    <li><a (click)="TogglePublic(false)" class="active"><i class="fa fa-table"></i></a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="content-details" [hidden]="ShowPublicTabView">
                            <div class="table-responsive">
                                <table class="table table-sm table-hover" aria-describedby="publicTable">
                                    <tbody>
                                        <tr>
                                            <th class="text-left fw-normal">
                                                Upto 1 month
                                            </th>
                                            <td class="text-right">
                                                18
                                            </td>
                                        </tr>
                                        <tr>
                                            <th class="text-left fw-normal">
                                                1 to 3 months
                                            </th>
                                            <td class="text-right">
                                                40
                                            </td>
                                        </tr>
                                        <tr>
                                            <th class="text-left fw-normal">
                                                3 to 6 months
                                            </th>
                                            <td class="text-right">
                                                50
                                            </td>
                                        </tr>
                                        <tr>
                                            <th class="text-left fw-normal">
                                                More than 6 months
                                            </th>
                                            <td class="text-right">
                                                20
                                            </td>
                                        </tr>
                                        <tr class="t-bold">
                                            <th class="text-left fw-normal">
                                                Total
                                            </th>
                                            <td class="text-right">
                                                128
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="mangmnt_graph" [hidden]="!ShowPublicTabView">
                            <div id="public-column"></div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Movement start -->
            <div class="col-lg-6">
                <div class="card">
                    <div class="card-header">
                        <div class="title d-flex justify-content-between">
                            <h2>Movement</h2>
                            <div class="view-data">
                                <ul>
                                    <li><a (click)="ToggleMovement(true)"><i class="fa fa-bar-chart"></i></a></li>
                                    <li><a (click)="ToggleMovement(false)" class="active"><i
                                                class="fa fa-table"></i></a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="content-details" [hidden]="ShowMovementTabView">
                            <div class="table-responsive">
                                <table class="table table-sm table-hover" aria-labelledby="table">
                                    <thead>
                                        <tr>
                                            <th style="width: 33%">
                                            </th>
                                            <th style="width: 33%">
                                                Rakes
                                            </th>
                                            <th style="width: 33%">
                                                Quantity (MT)
                                            </th>

                                        </tr>
                                    </thead>
                                    <tbody>

                                        <tr>
                                            <td class="text-left">
                                                Planned
                                            </td>
                                            <td class="text-right">
                                                0
                                            </td>
                                            <td class="text-right">
                                                0.00
                                            </td>

                                        </tr>
                                        <tr>
                                            <td class="text-left">
                                                Dispatched
                                            </td>
                                            <td class="text-right">
                                                18
                                            </td>
                                            <td class="text-right">
                                                53.50
                                            </td>

                                        </tr>
                                        <tr>
                                            <td class="text-left">
                                                Percentage
                                            </td>
                                            <td class="text-right">
                                                0.00
                                            </td>
                                            <td class="text-right">
                                                0.00
                                            </td>

                                        </tr>

                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="mangmnt_graph" [hidden]="!ShowMovementTabView">
                            <div id="movement-column"></div>
                        </div>
                    </div>
                </div>
            </div>



        </div>
    </div>
</div>

<!-- footer start -->
<footer class="footer text-white text-center p-3">
    ©2023 Food Corporation of India, Govt of India, All Rights Reserved
</footer>
<!-- footer end -->